import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed


const ListVibhags = () => {

  const handleRedirect = () => {
    navigate("/add/vibhag/");
  }

  const [Vibhags, setVibhags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const VibhagsPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthNames, setPranthNames] = useState({});

  const [selectedPranthId, setSelectedPranthId] = useState("1"); // default value
  const [pranthList, setPranthList] = useState([]);




  // const fetchPranthList = async () => {
  //   try {
  //     const response = await axiosPrivate.get('list-pranths'); // your actual endpoint here
  //     setPranthList(response.data);
  //   } catch (error) {
  //     console.error("Error fetching pranth list:", error);
  //     // fallback option if API is not available
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   }
  // };

  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);



  const fetchVibhag = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-vibhags?pranth_id=${selectedPranthId}`, {
        withCredentials: true,
      });

      const VibhagList = response.data;
      setVibhags(VibhagList);

      const pranthNameMap = {};
      await Promise.all(
        VibhagList.map(async (franchise) => {
          const pranthName = await fetchPranthName(franchise.vibhag_id);
          pranthNameMap[franchise.vibhag_id] = pranthName;
        })
      );
      setPranthNames(pranthNameMap);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Vibhags:", error);
      setError(error?.response?.data?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedPranthId]); // 👈 dependency added





  const fetchPranthName = async (vibhagId) => {
    try {
      const response = await axiosPrivate.get(`get-vibhag?vibhag_id=${vibhagId}`);
      return response.data.pranth_name;
    } catch (error) {
      console.error(`Error fetching pranth name for vibhag_id ${vibhagId}`, error);
      return "Unknown";
    }
  };


  const handleViewClick = (franchiseId) => {
    // Navigate to the Vibhag component with franchiseId as a URL parameter
    navigate(`/GetFranchise/${franchiseId}`);
  };
  const handleEditClick = (franchiseId) => {
    navigate(`/UpdateFranchise/${franchiseId}`);
  };



  useEffect(() => {
    fetchVibhag();
  }, [fetchVibhag]);

  useEffect(() => {
    fetchPranthList();
  }, []);


  const indexOfLastVibhag = currentPage * VibhagsPerPage;
  const indexOfFirstVibhag = indexOfLastVibhag - VibhagsPerPage;
  const currentVibhag = Vibhags.slice(indexOfFirstVibhag, indexOfLastVibhag);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(Vibhags.length / VibhagsPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Vibhags List</h3>

          <Form.Group controlId="pranthDropdown" className="mb-3">
            <Form.Label className="newformstyle">Select Pranth</Form.Label>
            <Form.Control
              as="select"
              value={selectedPranthId}
              onChange={(e) => setSelectedPranthId(e.target.value)}
              className="vibhaglist newselectstyle"
            >
              {pranthList.map((pranth) => (
                <option key={pranth.id} value={pranth.id}>
                  {pranth.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>


          <table id="customers">
            <thead>
              <tr>
                <th>Vibhag ID</th>
                <th>Vibhag Name</th>
                <th>Vibhag Name (MALAYALAM)</th>
                <th>Pranth Name</th>
                {/* <th>Options</th> */}
              </tr>
            </thead>

            <tbody>
              {error ? (
                <tr>
                  <td colSpan="6" className="text-danger text-center">
                    {error}
                  </td>
                </tr>
              ) : Vibhags.length === 0 ? (
                <tr>
                  <td colSpan="6">No Vibhags available.</td>
                </tr>
              ) : (
                currentVibhag.map(Vibhag => (
                  <tr key={Vibhag.vibhag_id}>
                    <td>{Vibhag.vibhag_id}</td>
                    <td>{Vibhag.search_tag}</td>
                    <td>{Vibhag.vibhag_name}</td>
                    <td>{pranthNames[Vibhag.vibhag_id] || "Loading..."}</td>
                    {/* <td>
                      <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-warning btn-ico newicobtn" onClick={() => handleEditClick(Vibhag.franchise_id)}>
                          <i className="bx bxs-edit icon"></i>
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>


          </table>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListVibhags;
